import { Col, Form, Input, Row, Select } from 'antd'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withData from '../../../../elements/Select/withData'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { strVal, findCascadersParents } from '../../../../modules/Utils'
import React from 'react'
import { compose } from 'recompose'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select

const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'bank',
    name: 'contract',
    cache: true,
    forceFetch: true,
  }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort,
)(CustomSelect)

function Overview (props) {
  const { getFieldDecorator, getFieldValue } = props.form
  const { contract } = props

  const { data: centers } = useFetchURL(`foxxapi/centers?select=_id,name,_parent`)

  const type = getFieldValue('type')

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <FormItem label="Title" {...defaultFormItemLayout}>
            {getFieldDecorator('title', {
              initialValue: strVal(contract, 'title'),
              rules: rules.input,
            })(<Input placeholder="Title"/>)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="Company" {...defaultFormItemLayout}>
            {getFieldDecorator('company._id', {
              initialValue: get(contract, 'company._id'),
              rules: rules.select,
            })(<OrganisationsSelect placeholder={'Select a Company'}/>)}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Investment Center">
            {getFieldDecorator('centers', {
              initialValue: findCascadersParents(centers, strVal(contract, 'center._id')),
              rules: rules.select,
            })(
              <CentersCascader
                category={'Investment'}
                company={getFieldValue('company._id')}
                key={getFieldValue('company._id')}
                disabled={!getFieldValue('company._id')}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem label="Type" {...defaultFormItemLayout}>
            {getFieldDecorator('type', {
              initialValue: get(contract, 'type'),
              rules: rules.select,
            })(<TypeSelect placeholder={'Select a Type'}/>)}
          </FormItem>
        </Col>
        {type === 'bank' && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Allow Overdraft'}>
              {getFieldDecorator('isOverdraft', {
                initialValue: get(contract, 'isOverdraft'),
              })(<OverdraftSelect/>)}
            </Form.Item>
          </Col>
        )}

        {type === 'deposit' && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Deposit Type'}>
              {getFieldDecorator('depositType', {
                initialValue: get(contract, 'depositType'),
              })(<LoanDepositTypeSelect/>)}
            </Form.Item>
          </Col>
        )}

        {type === 'loan' && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Loan Type'}>
              {getFieldDecorator('loadType', {
                initialValue: get(contract, 'loadType'),
              })(<LoanDepositTypeSelect/>)}
            </Form.Item>
          </Col>
        )}

        {type === 'card' && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label={'Card Type'}>
              {getFieldDecorator('cardType', {
                initialValue: get(contract, 'cardType'),
              })(<CardTypeSelect/>)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Description">
            {getFieldDecorator('description', {
              initialValue: get(contract, 'description'),
            })(<TextArea placeholder="Description" rows={4}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

const OverdraftSelect = compose(
  withData({
    data: [
      { value: 'Allow', key: true },
      { value: 'Disallow', key: false },
    ],
  }),
  withSort,
)(CustomSelect)

const CardTypeSelect = compose(
  withData({
    data: [
      { value: 'Credit', key: 'Credit' },
      { value: 'Debit', key: 'Debit' },
    ],
  }),
  withSort,
)(CustomSelect)

const LoanDepositTypeSelect = compose(
  withData({
    data: [
      { value: 'Fixed', key: 'Fixed' },
      { value: 'Variable', key: 'Variable' },
    ],
  }),
  withSort,
)(CustomSelect)

export default Form.create()(Overview)
